import { Component, Inject, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { SystemErrorData } from '../models/systemErrorData.model';
import { SystemErrorDataService } from '../services/system-error.service';
import { SharedLibConfig } from '../../../config/shared-lib-config';
import { SHARED_LIB_CONFIG } from '../../../config/shared-lib-config.token';
import { AuthService } from '../../../services/auth/auth.service';

/**
 * システムエラー画面
 * @example
 * SystemErrorDataServiceをDIして画面情報を設定し、本コンポーネントに遷移する
 * 
 *【呼び出し元】
 * constructor(private SystemErrorDataService systemErrorDataService) { }
 * 
 * this.systemErrorDataService.systemErrorData = {
 *   messageId: 'messageId_001', 
 *   message: 'エラーメッセージ',　
 *   errorDetail: 'エラー内容詳細',                     
 * }
 * this.router.navigate(['/sgkz002d/']);
 * @export
 * @class Sgkz002dComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-sgkz002d',
  templateUrl: './sgkz002d.component.html',
  styleUrls: ['./sgkz002d.component.scss']
})
export class Sgkz002dComponent implements OnInit, OnDestroy {

  /**
   * 開発環境・本番環境判定フラグ
   */
  isProduction = this.sharedLibConfig.production;

  /**
   * 画面表示項目
   * @type {SystemErrorData}
   * @memberof Sgkz002dComponent
   */
  systemErrorData: SystemErrorData = {
    messageId: '',
    message: '',
    errorDetail: '',
  };

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /**
  * コンストラクタ
  * @param {FormBuilder} fb
  * @memberof Sgkz002dComponent
  */
  constructor(
    private systemErrorDataService: SystemErrorDataService,
    private authService: AuthService,
    @Inject(SHARED_LIB_CONFIG) private sharedLibConfig: SharedLibConfig
  ) {
  }

  /**
  * 初期処理
  * @memberof Sgkz002dComponent
  */
  ngOnInit(): void {
    // 完了画面データの購読設定
    this.systemErrorDataService.valueChange
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        this.systemErrorData = data;
      });

    // 遷移時、ログアウト処理を行う。
    this.authService.logout(true);
    // セッションストレージの削除。
    sessionStorage.clear();
  }

  /**
   * コンポーネント破棄処理
   * SystemErrorDataServiceをクリアする
   * @memberof SystemErrorDataService
   */
  ngOnDestroy(): void {
    this.systemErrorDataService.initializeData();
  }
}